export default __webpack_public_path__ + "a862b5d15dcf23a2e635d299c28be6f0.png";